import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ExternalUserRouteGuard: React.FC = () => {
  const externalUserDetailsString = localStorage.getItem("ExternalUserDetails");

  let isAuthenticated = false;

  if (externalUserDetailsString) {
    try {
      const externalUserDetails = JSON.parse(externalUserDetailsString);
      isAuthenticated = !!externalUserDetails?.tempSessionToken;
    } catch (e) {
      console.error("Invalid ExternalUserDetails format in localStorage", e);
    }
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default ExternalUserRouteGuard;
